import { render, staticRenderFns } from "./sign-in-overlay.vue?vue&type=template&id=41561f83&"
import script from "./sign-in-overlay.vue?vue&type=script&lang=js&"
export * from "./sign-in-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports